import { ButtonContained, ButtonMenu, ContentFeedback, CustomText, Pagination, Table } from "../../components/index";
import Styles from "./styles";
import { masks } from "../../utils";
import { hooks } from "../../utils";
import { fonts, SVG } from "../../config";
import { ExpandMore, Visibility, Update } from "@material-ui/icons";
import { customModal } from "../../components/modals/utils";
import { StorageContext } from "../../contexts/StorageContext";
import ModalView from "./components/ModalView";
import { api } from "../../services";
import { useState, useEffect, useCallback, useContext } from "react";

const PAGE_SIZE = 8;

function Monitoring() {
  const [page, setPage] = useState<number>(0);
  const { loading, call } = hooks.useRequest();
  const [monitoring, setMonitoring] = useState<any>(null);
  const [toggleDeviceList, setToggleDeviceList] = useState(false);
  const [isMounted, setMount] = useState<boolean>(false);
  const [places, setPlaces] = useState<any>([]);
  const [lastUpdateDate, setLastUpdateDate] = useState("");
  const [isLoadingDevices, setIsLoadingDevices] = useState(false);
  const { getData } = useContext<any>(StorageContext);
  const condominiumId = getData("company_type");
  const actions = [
    { id: "RESERVATION_CHECK_IN", label: "Check-in realizado" },
    { id: "RESERVATION_CHECK_OUT", label: "Check-out realizado" },
    { id: "TUYA_PASSWORD_CREATE", label: "Senha Tuya criada" },
    {
      id: "TUYA_VISITANT_RESERVATION_PASSWORD_CREATE",
      label: "Senha para visitante criada (Tuya)",
    },
    {
      id: "TUYA_TENANT_RESERVATION_PASSWORD_CREATE",
      label: "Senha para morador criada (Tuya)",
    },
    {
      id: "TUYA_VISITANT_RESERVATION_PASSWORD_DELETE",
      label: "Senha de visitante excluída (Tuya)",
    },
    {
      id: "TUYA_TENANT_RESERVATION_PASSWORD_DELETE",
      label: "Senha de morador excluída (Tuya)",
    },
    {
      id: "TUYA_SERVICE_PROVIDER_RESERVATION_PASSWORD_CREATE",
      label: "Senha para prestador de serviço criada (Tuya)",
    },
    {
      id: "TUYA_SERVICE_PROVIDER_RESERVATION_PASSWORD_DELETE",
      label: "Senha de prestador de serviço excluída (Tuya)",
    },
    {
      id: "TUYA_PASSWORD_WHATSAPP_MESSAGE",
      label: "Senha enviada via WhatsApp (Tuya)",
    },
    {
      id: "TUYA_VISITANT_PASSWORD_WHATSAPP_MESSAGE",
      label: "Senha de visitante enviada via WhatsApp (Tuya)",
    },
    { id: "TUYA_PASSWORD_EMAIL", label: "Senha enviada via e-mail (Tuya)" },
    {
      id: "TUYA_VISITANT_PASSWORD_EMAIL",
      label: "Senha de visitante enviada via e-mail (Tuya)",
    },
    {
      id: "TUYA_TENANT_PASSWORD_EMAIL",
      label: "Senha de morador enviada via e-mail (Tuya)",
    },
    {
      id: "TUYA_SERVICE_PROVIDER_PASSWORD_EMAIL",
      label: "Senha de prestador de serviço enviada via e-mail (Tuya)",
    },
    { id: "TUYA_PASSWORD_EDIT", label: "Senha editada (Tuya)" },
    { id: "TUYA_PASSWORD_DELETE", label: "Senha excluída (Tuya)" },
    { id: "SEGWARE_DELETE_RENTER", label: "Locatário excluído (Segware)" },
    {
      id: "SEGWARE_FACIAL_RENTER",
      label: "Reconhecimento facial de hóspede realizado (Segware)",
    },
    {
      id: "SEGWARE_FACIAL_VISITANT_RESERVATION",
      label: "Reconhecimento facial de visitante realizado (Segware)",
    },
    {
      id: "SEGWARE_FACIAL_TENANT_RESERVATION",
      label: "Reconhecimento facial de morador realizado (Segware)",
    },
    {
      id: "SEGWARE_FACIAL_SERVICE_PROVIDER_RESERVATION",
      label: "Reconhecimento facial de prestador de serviço realizado (Segware)",
    },
    { id: "SEGWARE_SAVE_RENTER", label: "Hóspede salvo (Segware)" },
    { id: "SEGWARE_EDIT_RENTER", label: "Hóspede editado (Segware)" },
    {
      id: "SEGWARE_VISITANT_EDIT_RENTER",
      label: "Visitante editado (Segware)",
    },
    { id: "SEGWARE_TENANT_EDIT_RENTER", label: "Morador editado (Segware)" },
    {
      id: "SEGWARE_SERVICE_PROVIDER_EDIT_RENTER",
      label: "Prestador de serviço editado (Segware)",
    },
  ];

  const Mount = useCallback(async () => {
    call(null, api.getMonitoringList({ page: 0, size: PAGE_SIZE, sort: "id,desc" }), async (response) => {
      if (response.ok) {
        setMonitoring(response.data);
      }
    });
    updatePlaces();
  }, []);

  const updateDevices = async () => {
    if (isLoadingDevices) return;
    setIsLoadingDevices(true);
    call(null, api.updateDevices(), async (response) => {
      if (response.ok) {
        setTimeout(() => {
          checkIfStillUpdating();
        }, 60000);
      }
    });
  };

  const checkIfStillUpdating = async () => {
    call(null, api.checkDevicesIsUpdating(), async (response) => {
      if (response.ok) {
        if (response.data?.value) {
          setTimeout(() => {
            checkIfStillUpdating();
          }, 60000); ///300000
        } else {
          setIsLoadingDevices(false);
          const date = new Date(Date.now())
            .toLocaleString("pt-BR", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })
            .replace(",", " -");
          setLastUpdateDate(date);
          updatePlaces();
        }
      }
    });
  };

  useEffect(() => {
    updatePlaces();
  }, [lastUpdateDate]);

  useEffect(() => {
    if (!isMounted) {
      Mount();
      setMount(true);
    }
  }, [Mount, isMounted]);

  const updatePlaces = () => {
    let filters = {
      page: page ? page : 0,
      size: PAGE_SIZE,
      condominiumId: condominiumId,
    };
    call(null, api.getPlaces(filters), async (response) => {
      if (response.ok) {
        setPlaces(response?.data);
        if (lastUpdateDate == "" && response?.data?.content?.length > 0) {
          const iso = response?.data?.content[0].deviceStatus?.startDate;
          const dateAdjusted = new Date(new Date(iso).getTime() - 3 * 60 * 60 * 1000);
          const dateFormatted = new Date(dateAdjusted)
            .toLocaleString("pt-BR", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })
            .replace(",", " -");
          setLastUpdateDate(dateFormatted);
        }
      }
    });
  };

  const Submit = async (page?: number) => {
    let filters = {
      page: page ? page : 0,
      size: PAGE_SIZE,
      sort: "id,desc",
    };

    call(null, api.getMonitoringList(filters), async (response) => {
      if (response.ok) {
        setMonitoring(response?.data);
        setPage(page ? page : 0);
      }
    });
  };

  const openModalView = (item) => {
    customModal.setInfos(
      "Visualizar Dados",
      [],
      {
        onClick: () => {
          customModal.close();
        },
        label: "Voltar",
      },
      null,
      <ModalView item={item.apiLogs} />,
      false,
      true,
      <Visibility />,
    );
  };

  const getButtons = (item: any): any[] => {
    return [
      {
        label: "Visualizar Dados",
        icon: Visibility,
        onClick: () => {
          openModalView(item);
        },
      },
    ];
  };
  function convertToBrazilTime(dateString) {
    const date = new Date(dateString);
    const adjustedDate = new Date(date.getTime() - 3 * 60 * 60 * 1000);
    return adjustedDate.toISOString();
  }
  return (
    <>
      <div style={{ display: "flex" }}>
        <ButtonContained
          fullWidth={false}
          visuallyDisabled={toggleDeviceList}
          onClick={() => setToggleDeviceList(false)}
          style={{ width: "50%", borderRadius: "20px 0% 0% 0%" }}
        >
          Lista de Monitoramentos
        </ButtonContained>
        <ButtonContained
          fullWidth={false}
          visuallyDisabled={!toggleDeviceList}
          onClick={() => setToggleDeviceList(true)}
          style={{ width: "50%", borderRadius: " 0% 20px 0% 0%" }}
        >
          Dispositivos
        </ButtonContained>
      </div>
      {!toggleDeviceList ? (
        <Styles.Container>
          <ContentFeedback data={monitoring?.content} loading={loading}>
            <Table
              lastAlign={false}
              data={monitoring?.content}
              renderItemColumns={(item) => [
                item?.id,
                actions.find((i) => i.id == item?.type)?.label || "-",
                masks.formatDate(item?.editedAt) + " - " + masks.formatDateHour(convertToBrazilTime(item?.editedAt)),
                masks.formatDate(item?.createdAt) + " - " + masks.formatDateHour(convertToBrazilTime(item?.createdAt)),
                <ButtonMenu endIcon={<ExpandMore />} buttons={getButtons(item)}>
                  Opções
                </ButtonMenu>,
              ]}
              headers={{
                table: ["ID Tarefa", "Tipo Tarefa", "Data / Hora Envio", "Data / Hora Criação Tarefa", "Ação"],
                keys: [],
              }}
            />
            <Pagination
              style={{ padding: "16px 20px", paddingTop: 0 }}
              page={page + 1}
              totalPages={monitoring?.totalPages}
              setPage={(number) => {
                Submit(number - 1);
              }}
            />
          </ContentFeedback>
        </Styles.Container>
      ) : (
        <Styles.Container>
          <div style={{ padding: "20px", width: "100%" }}>
            <Styles.ContainerSecondary>
              <Styles.RegitryContainer>
                {isLoadingDevices ? (
                  <CustomText fontSize={1.75} textColor="#FFFFFF" fontFamily={fonts.bold}>
                    A atualização deverá ocorrer em 5 minutos
                  </CustomText>
                ) : (
                  lastUpdateDate != "" && (
                    <>
                      <CustomText fontSize={1.75} textColor="#FFFFFF" fontFamily={fonts.bold}>
                        Última atualização:
                      </CustomText>
                      <CustomText
                        style={{ paddingRight: "8px" }}
                        fontSize={1.75}
                        textColor="#FFFFFF"
                        fontFamily={fonts.regular}
                      >
                        {lastUpdateDate}
                      </CustomText>
                    </>
                  )
                )}
              </Styles.RegitryContainer>
              <Styles.RegitryButton
                fullWidth={false}
                disabled={isLoadingDevices}
                startIcon={<Update />}
                loading={isLoadingDevices}
                alternative
                onClick={() => updateDevices()}
              >
                Atualizar Agora
              </Styles.RegitryButton>
            </Styles.ContainerSecondary>
          </div>
          <ContentFeedback data={monitoring?.content} loading={loading}>
            <Table
              lastAlign={true}
              data={places?.content}
              renderItemColumns={(item) => [item?.name, item?.deviceStatus?.id, item?.deviceStatus?.description]}
              headers={{
                table: ["Imóvel", "ID Fechadura", "Status Fechadura"],
                keys: [],
              }}
            />
            <Pagination
              style={{ padding: "16px 20px", paddingTop: 0 }}
              page={page + 1}
              totalPages={places?.totalPages}
              setPage={(number) => {
                Submit(number - 1);
              }}
            />
          </ContentFeedback>
        </Styles.Container>
      )}
    </>
  );
}

export default Monitoring;
